<section>

    <div class="flex justify-between items-end">
        <div>
            <h1>Client</h1>
        </div>
        <div class="flex items-center gap-3">
            <div class="dropdown dropdown-bottom dropdown-end">
                <div tabindex="0" role="button" class="btn btn-sm bg-white  border flex items-center">Action <i
                        class="ri-arrow-down-s-line"></i></div>
                <ul tabindex="0"
                    class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow mt-2 text-sm font-semibold">
                    <li><a>Import via CSV</a></li>
                    <li><a>Export PDF</a></li>
                    <li><a>Export CSV</a></li>
                    <li><a>Export Excel</a></li>
                </ul>
            </div>
            <a [routerLink]="['create']" class="btn btn-sm flex items-center btn-primary"><i class="ri-add-line"></i>
                Create Client</a>

        </div>
    </div>

    <!-- serach Parameter form -->
    <form action="" class="hidden">
        <div class="flex flex-wrap justify-between items-center mt-5 gap-3">
            <div class="flex flex-wrap items-center gap-3">

                <select class="select select-sm select-bordered w-32 text-xs font-semibold">
                    <option selected disabled>Departments</option>

                </select>

                <select class="select select-sm select-bordered w-32 text-xs font-semibold">
                    <option selected disabled>Class</option>

                </select>
                <select class="select select-sm select-bordered w-32 text-xs font-semibold">
                    <option selected disabled>Batch</option>

                </select>
                <select class="select select-sm select-bordered w-32 text-xs font-semibold">
                    <option selected disabled>Academic Year</option>
                    <option class="text-base">option 1</option>
                    <option class="text-base">option 2</option>
                    <option class="text-base">option 3</option>
                    <option class="text-base">option 4</option>
                </select>
                <select class="select select-sm select-bordered w-32 text-xs font-semibold">
                    <option selected disabled>status</option>
                    <option class="text-base">option 1</option>
                    <option class="text-base">option 2</option>
                    <option class="text-base">option 3</option>
                    <option class="text-base">option 4</option>
                </select>
            </div>

            <div class="flex items-center gap-3">
                <label class="input input-sm input-bordered flex items-center gap-2">
                    <i class="ri-search-line"></i>
                    <input type="text" class="grow" placeholder="Search" />
                </label>

                <button class="btn btn-sm btn-primary btn-square"><i class="ri-filter-3-line"></i></button>
            </div>

        </div>
    </form>
    <!-- serach Parameter form -->

    <div class="p-5 bg-white rounded-lg mt-5 border">

        <div class="overflow-x-auto">
            <table class="table table-auto w-full">
                <!-- head -->
                <thead>
                    <tr>
                        <th class="w-14"><input type="checkbox" class="checkbox checkbox-sm" /></th>
                        <th class="w-auto">Client Name</th>
                        <th>Contact Details</th>
                        <th>Company</th>
                        <!-- <th>status</th> -->
                        <th class="w-56">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- row 1 -->
                    @for (i of clients; track $index) {
                    <tr>
                        <th><input type="checkbox" class="checkbox checkbox-sm" /></th>
                        <td class="whitespace-nowrap font-semibold">{{i?.name}}</td>
                        <td class="flex flex-col">
                            <span>{{i?.email}}</span>
                            <span>{{i?.phone}}</span>
                        </td>
                        <td>{{i?.company}}</td>

                        <td>
                            <div class="flex gap-2 justify-center">
                                <a [routerLink]="['view', i?.id]" class="btn btn-sm flex items-center btn-light"><i
                                        class="ri-eye-line"></i></a>
                                <a [routerLink]="['edit', i?.id]" class="btn btn-sm flex items-center btn-light"><i class="ri-pencil-line"></i></a>
                                <a class="btn btn-sm flex items-center btn-light"><i
                                        class="ri-delete-bin-line"></i></a>
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>



    </div>


    <!-- 
  <div class="mt-5 flex justify-center">
    <app-pagination></app-pagination>
  </div> -->


</section>
<!-- create/edit student modal -->
<!-- @if (isMoaldalOpen) {
<app-student-form-modal [studentId]="studentId" [isOpen]="isMoaldalOpen"
  (closeModalemmit)="emitedData($event)"></app-student-form-modal>
} -->
<!-- create/edit student modal -->